/**
 * Toggle between the two Upload & Match loading behaviors. Flip this single
 * constant and rebuild to switch modes.
 *
 * - `true`  (CX-2387): prefetch the first material search during the loading
 *   screen and only advance to the results view once it succeeds, then seed the
 *   results so they paint with no second loading pass.
 * - `false` (legacy): advance to the results view as soon as color extraction
 *   finishes; the results view then issues the search itself (extra loading).
 */
export const PREFETCH_SEARCH_BEFORE_RESULTS = true;
